import { render } from "./RevistaEletronica.vue?vue&type=template&id=76c8a38f&scoped=true&ts=true"
import script from "./RevistaEletronica.vue?vue&type=script&lang=ts"
export * from "./RevistaEletronica.vue?vue&type=script&lang=ts"

import "./RevistaEletronica.vue?vue&type=style&index=0&id=76c8a38f&scoped=true&lang=css"

import exportComponent from "/home/arthur/ProjetoVue/revista/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76c8a38f"]])

export default __exports__